export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7363.6be202bd.jpg";